const MiceCard = ({ title, img }) => {
    const backgroundStyle = {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
    }

    return (
        <div className="mice-card" style={backgroundStyle}>
            <div className="mice-card__content">
                <h2 className="card-title">{title}</h2>
            </div>
        </div>
    )
}

export default MiceCard
